import React, { useEffect, useState } from "react";
import { Row, Col, Drawer, notification } from "antd";
import { componentStyles } from "./UserDrawerStyles";
import DrawerMenu from "./DrawerMenu";
import { getUser } from "../../api/password";
import userImage from "../../assets/images/Drawer_Image.svg";
import { getImageUrlOfUserProfile } from '../../api/User.js';

const UserDrawer = ({ isDrawerOpen, onClose, setIsDrawerOpen }) => {
  const [title, setTitle] = useState("");
  const [imageUrl, setImageUrl] = useState('');

  const fetchImageUrl = async () => {
    try {
      const response = await getImageUrlOfUserProfile();
      if (response && response.profileImageUrl) {
        setImageUrl(response.profileImageUrl);
      }
    } catch (error) {
      console.error("Error fetching profile image URL:", error);
      notification.error({
        message: 'Fetch Failed',
        description: 'There was an error fetching your profile image. Please try again.',
        placement: 'topRight',
      });
    }
  };

  useEffect(() => {
    fetchImageUrl();
  }, []);

  useEffect(() => {
    const getUserInfo = async () => {
      try {
        const response = await getUser();
        if (response.id) {
          setTitle(response.name);
        } else {
          setTitle("");
        }
      } catch (err) {
        console.log(err);
      }
    };

    getUserInfo();
  }, []);

  return (
    <Drawer className="profile-drawer"
      title={
        <Row gutter={16} justify={"start"} align={"middle"}>
          <Col xs={24} sm={24} md={8} lg={8}>
            <img src={imageUrl || userImage} alt="User Image" style={componentStyles.mainImageStyling} />
          </Col>
          <Col className="mt-2" xs={24} sm={24} md={16} lg={16} >
            <span style={componentStyles.drawerTitle}>{title}</span>
          </Col>
        </Row>
      }
      placement="right"
      onClose={onClose}
      open={isDrawerOpen}
      mask={true}
      maskClosable={true}
      closable={true}
    >
      <Row>
        <Col span={24}>
          <DrawerMenu onClose={onClose} />
        </Col>
      </Row>
    </Drawer>
  );
};

export default UserDrawer;
